import React, {Component} from 'react';
import Person from './Person';

export default class PersonList extends Component {
  state = {
    value: ''
  };

  people = [
    {
      img: 56,
      name: 'eric',
      job: 'developer'
    },
    {
      img: 34,
      name: 'manzi',
      job: 'space agent'
    },
    {
      img: 22,
      name: 'john',
      job: 'worker'
    }
  ];

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  // detecting screen size
  resize() {
    if (window.innerWidth <= 760) {
      this.setState({value: ''});
    } else {
      this.setState({value: 'personlist'});
    }
  }

  render() {
    return (
      <div className={this.state.value}>
        <Person person={this.people[0]}>Lorem ipsum dolor sit amet.</Person>
        <Person person={this.people[1]}>Lorem ipsum dolor sit amet.</Person>
        <Person person={this.people[2]}>Lorem ipsum dolor sit amet.</Person>
      </div>
    );
  }
}
